
import { STATE, A, IS, TURN } from '../../States';
import { FdmPlugin, FdmPluginInterface } from '../plugins';

const Cesium = (<any>window).Cesium;

/* LOG
    * created (17/06/2012)
*/

export class SceneLiveDataController extends FdmPlugin implements FdmPluginInterface {

    static meta = {

        label: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER.LABEL',
        name: 'live-data-scene-controller',
        translator: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER',
        tooltip: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER.TOOLTIP',
        shortcut: true,
        shortcutOnlyVisible: true,
        icon: 'rss',

        category: FdmPlugin.category.experimental,

        types: [ FdmPlugin.types.sceneController ],
        cardinality: FdmPlugin.cardinality.one,
    };

    controls:any = {
        active: { value:false, type:'check' },
    }


    init() {
        // create data store here
    }
    end() {
        // remove data store here
    }

}
